import graphql__34013183abe5d91725e2 from "./__generated__/ParticipativeModuleCard_participativeModule.graphql.js";import { graphql, useFragment } from "react-relay";
import { defineMessages } from "react-intl";

import ButtonLink from "../Buttons/ButtonLink";
import CardStep from "../Steps/CardStep";
import ParticipativeModuleCardThumb from "./ParticipativeModuleCardThumb";
import { Desktop, NonDesktop } from "../Utils/ResponsiveQueries";
import { useFormatMessage } from "../Intl/Context";
import { useRoutesContext } from "../Routes/RoutesContext";
import ParticipativeModuleMeasures from "./ParticipativeModuleMeasures";

const CARD_HEADER_CLASS_NAME =
  "card-header padding-sm text-title-overview margin-bottom-xs flex-1";

const ParticipativeModuleCard = props => {
  const participativeModule = useFragment(
    ParticipativeModuleCard_participativeModule,
    props.participativeModule
  );
  const {
    title,
    thumbUrl,
    currentStep,
    slug: participativeModuleSlug
  } = participativeModule;

  const { iconClass } = participativeModule.visualization;

  const t = useFormatMessage();
  const see = t(intlMessages.see);

  const { pathFor } = useRoutesContext();
  const participativeModulePath = pathFor("participativeModule", {
    participativeModuleSlug
  });

  return (
    <>
      <Desktop>
        <div className="card box box-shadow minh-100">
          <div className={CARD_HEADER_CLASS_NAME}>{title}</div>

          <ParticipativeModuleCardThumb thumbUrl={thumbUrl} iconClassName={iconClass} />

          <div className="participative-module-card-metrics flex-1 margin-y-xs">
            <ParticipativeModuleMeasures
              participativeModule={participativeModule}
              className="box bg-white justify-content-center padding-sm"
            />

            <CardStep step={currentStep} className="padding-sm" />
          </div>

          <ButtonLink
            href={participativeModulePath}
            className="btn btn-primary btn-block-md card-footer border-radius"
            label={see}
            iconClassName="icon-arrow-right"
            iconPosition="after"
          />
        </div>
      </Desktop>

      <NonDesktop>
        <div className="card box box-shadow h-100">
          <div className={CARD_HEADER_CLASS_NAME}>{title}</div>

          <ParticipativeModuleCardThumb thumbUrl={thumbUrl} iconClassName={iconClass} />

          <div className="margin-bottom-xxs">
            <ParticipativeModuleMeasures
              participativeModule={participativeModule}
              className="box bg-white justify-content-center padding-md"
            />
          </div>

          <div className="margin-bottom-xxs">
            <CardStep step={currentStep} className="padding-md" />
          </div>

          <ButtonLink
            href={participativeModulePath}
            className="card-footer btn btn-primary btn-block-md"
            label={see}
            iconClassName="icon-arrow-right"
            iconPosition="after"
          />
        </div>
      </NonDesktop>
    </>
  );
};

const ParticipativeModuleCard_participativeModule = graphql__34013183abe5d91725e2;

export default ParticipativeModuleCard;

const intlMessages = defineMessages({
  see: {
    id: "participativeModule.card.see",
    defaultMessage: "Voir le détails"
  }
});
